export default "__VITE_ASSET__BKQTmyUD__"